import Escudo from "../assets/img/escudo.svg";
import Button from "./Button";
import IconoCerrarSesion from "../assets/img/cs.svg";
import { Link, useNavigate } from "react-router-dom";
import { SignOut } from "../utils/auth";
import { useEffect, useState } from "react";
import { imgUrl, serverUrl } from "../serverURL";

const Navegacion = ({ isVerificado }) => {
  const navigate = useNavigate();
  const handleLogOut = () => {
    SignOut();
    navigate("/");
  };

  const [userData, setUserData] = useState();

  useEffect(() => {
    const fetchUserData = async () => {
      const res = await fetch(serverUrl + "/getNavbarData", {
        headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
      });
      const json = await res.json();

      if (json.status !== "OK") {
        return null;
      } else {
        return json;
      }
    };

    if (isVerificado) {
      fetchUserData().then((json) => {
        if (json) {
          setUserData(json.userData);
        } else {
          setUserData(null);
        }
      });
    }
  }, [isVerificado]);

  return (
    <header>
      <nav className="nav-container">
        {window.innerWidth > 768 && (
          <Link to={"/"}>
            <img src={Escudo} alt="Escudo river plate" className="escudo" />
          </Link>
        )}
        <div className="nav-links">
          {isVerificado && userData ? (
            <div className="nav-medio">
              <img
                src={`${imgUrl}/${userData.context.icono}`}
                alt="Logo del medio"
                className="logo-medio"
              />
              <div className="info-medio">
                <p>{userData.context.medio}</p>
                <span>{userData.context.nombre}</span>
              </div>
            </div>
          ) : (
            ""
          )}
          {window.innerWidth < 768 && (
            <Link to={"/"}>
              <img src={Escudo} alt="Escudo river plate" className="escudo" />
            </Link>
          )}
          {isVerificado && (
            <Button variant={"cerrar-ses"} onClick={handleLogOut}>
              <img src={IconoCerrarSesion} alt="Cerrar sesión" />
              <span>Cerrar sesión</span>
            </Button>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Navegacion;
